/* Sticky Product CTA bar visibility controller */
(function () {
  'use strict';

  function init() {
    var bar = document.querySelector('[data-sticky-product-cta]');
    if (!bar) return;

    // Sentinel: the main product section. Bar appears once it has scrolled out of view.
    var triggerSelector = bar.getAttribute('data-trigger-selector') || '';
    var trigger = triggerSelector ? document.querySelector(triggerSelector) : null;
    if (!trigger) {
      trigger = document.getElementById('shopify-section-main') ||
                document.querySelector('.shopify-section .product:not(.product--related)') ||
                document.querySelector('main-product') ||
                document.querySelector('.product__info-wrapper');
    }
    if (!trigger) return;

    var show = function () { bar.classList.add('is-visible'); };
    var hide = function () { bar.classList.remove('is-visible'); };

    // Footer sentinel: hide bar once footer is in view.
    var footer = document.querySelector('.shopify-section-group-footer-group') ||
                 document.querySelector('footer.footer') ||
                 document.querySelector('#shopify-section-footer') ||
                 document.querySelector('footer');

    // Show after part of the trigger section has scrolled past the top of the viewport.
    // Desktop: ~50% scrolled. Mobile: appear later (~90% scrolled).
    var check = function () {
      var rect = trigger.getBoundingClientRect();
      var isMobile = window.matchMedia('(max-width: 749px)').matches;
      var ratio = isMobile ? 0.1 : 0.5;
      var pastTrigger = rect.bottom <= rect.height * ratio;

      var footerVisible = false;
      if (footer) {
        var fRect = footer.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight;
        if (fRect.top < vh) footerVisible = true;
      }

      if (pastTrigger && !footerVisible) show(); else hide();
    };

    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check, { passive: true });
    check();

    // --- Variant change syncing -------------------------------------------------
    var variants = [];
    try {
      var dataEl = bar.querySelector('[data-sticky-cta-variants]');
      if (dataEl) variants = JSON.parse(dataEl.textContent);
    } catch (e) { variants = []; }

    var priceEl = bar.querySelector('[data-sticky-cta-price]');
    var textEl = bar.querySelector('.sticky-product-cta__btn-text');
    var btnEl = bar.querySelector('.sticky-product-cta__btn');
    var idInput = bar.querySelector('input[name="id"]');

    function findVariant(id) {
      id = String(id);
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === id) return variants[i];
      }
      return null;
    }

    function applyVariant(id) {
      if (!id) return;
      var v = findVariant(id);
      if (idInput) idInput.value = id;
      if (!v || !textEl) return;

      if (v.available) {
        if (btnEl) btnEl.disabled = false;
        var defaultText = textEl.getAttribute('data-default-text') || '';
        textEl.innerHTML = '';
        if (priceEl) {
          textEl.appendChild(document.createTextNode(defaultText + ' - '));
          priceEl.textContent = v.price;
          textEl.appendChild(priceEl);
        } else {
          textEl.textContent = defaultText;
        }
      } else {
        if (btnEl) btnEl.disabled = true;
        textEl.textContent = textEl.getAttribute('data-soldout-text') || 'Sold out';
      }
    }

    // Listen to the main product form's variant id input changes
    var mainIdInputs = document.querySelectorAll('form[action*="/cart/add"] input[name="id"]');
    mainIdInputs.forEach(function (input) {
      if (input === idInput) return;
      input.addEventListener('change', function () {
        applyVariant(input.value);
      });
    });

    // Also listen for URL changes (some themes only update the URL on variant change)
    var lastUrlVariant = new URL(window.location.href).searchParams.get('variant');
    var pollUrl = function () {
      var v = new URL(window.location.href).searchParams.get('variant');
      if (v && v !== lastUrlVariant) {
        lastUrlVariant = v;
        applyVariant(v);
      }
    };
    window.addEventListener('popstate', pollUrl);
    setInterval(pollUrl, 600);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
